import { Navigate } from '@tanstack/react-router';
import { AnalyticsSupportedSocialMediaType } from '@anytag/shared-types';
import { useAnalyticsProfileContext } from '../analytics-profile-context';
import { AnalyticsCompareInstagram } from './analytics-compare-instagram';
import { AnalyticsCompareYoutube } from './analytics-compare-youtube';

export const AnalyticsCompare = () => {
  const {
    selectedSocialAccount,
    brandAccount: { subscriptionPlan }
  } = useAnalyticsProfileContext();
  const hasFreePlan = subscriptionPlan.availableFeatures?.compareEnabled === false;

  switch (selectedSocialAccount.socialMedia) {
    case AnalyticsSupportedSocialMediaType.youtube:
      return <AnalyticsCompareYoutube hasFreePlan={hasFreePlan} />;
    case AnalyticsSupportedSocialMediaType.instagram:
      return <AnalyticsCompareInstagram hasFreePlan={hasFreePlan} />;
    default:
      return <Navigate to="/analytics" />;
  }
};
